import { Controller, useFormContext } from "react-hook-form";
import { SimpleSelect } from "~/common/components/Select/SimpleSelect";
import classNames from "classnames";
import { useMemo } from "react";
import { type DropdownEntry } from "~/common/types";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
}

export const enum OrderbookConfirmedDeliveryStatus {
  ALL = "all",
  CONFIRMED = "confirmed",
  UNCONFIRMED = "unconfirmed",
}
export const OrderbookLineConfirmedDeliveryEntries: DropdownEntry<string>[] = [
  {
    label: "page.abmonitor.filter.linestatus.all",
    value: OrderbookConfirmedDeliveryStatus.ALL,
  },
  {
    label: "page.abmonitor.filter.linestatus.confirmed",
    value: OrderbookConfirmedDeliveryStatus.CONFIRMED,
  },
  {
    label: "page.abmonitor.filter.linestatus.unconfirmed",
    value: OrderbookConfirmedDeliveryStatus.UNCONFIRMED,
  },
];

export const ConfirmedDeliveryLineFilter = (props: Props) => {
  const formHooks = useFormContext();
  const { t } = useTranslation();

  const values = useMemo(() => {
    return OrderbookLineConfirmedDeliveryEntries.map((entry) => ({ ...entry, label: t(entry.label as string) }));
  }, [t]);

  return (
    <Controller
      render={({ field: { value, onChange } }) => (
        <SimpleSelect
          label={t("orderList.orderConfirmedDeliveryStatus")}
          className={classNames(props.className)}
          fullWidth={true}
          values={values}
          value={value}
          displayEmpty={true}
          shrink={true}
          onChange={onChange}
          data-test-id={"confirmed-status-select"}
        />
      )}
      name={"confirmedLines"}
      control={formHooks.control}
      defaultValue={OrderbookLineConfirmedDeliveryEntries[0].value}
    />
  );
};
